import React from 'react';
import {amountFormatter, isArrayEmpty} from '@utils/helpers';
import CategoryProductList from "@components/Menu/Product";
import {useTranslation} from "react-i18next";

const MenuForm = ({
                    menu,
                    selectedProducts,
                    setSelectedProducts,
                    total,
                    categoryRefs,
                    setActiveForm,
                    viewMode
                  }) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-col justify-between">
      <div className="w-full bg-white rounded-xl shadow-even justify-between items-center">
        {menu?.map((category, index) => {
          if (isArrayEmpty(category?.magProducts)) {
            return null;
          }

          return (
            <CategoryProductList
              viewMode={viewMode}
              key={category.id}
              inLastCategory={menu.length - 1 === index}
              category={category}
              categoryRefs={categoryRefs}
              selectedProducts={selectedProducts}
              setSelectedProducts={setSelectedProducts}
            />
          );
        })}
      </div>
      {selectedProducts.length > 0 &&
        <div className="sticky w-full shadow-sm bottom-0 flex items-center justify-end py-3 px-3">
          <button onClick={() => {
            setActiveForm('checkout');
            window.scrollTo(0, 0);
          }}
                  className="py-4 px-2 text-base group w-full relative justify-center font-medium rounded-3xl text-white bg-gradient-to-r from-cyan-600 from-10% via-sky-800 via-30% to-blue-800 to-90% hover:bg-gradient-to-r hover:from-cyan-600 hover:from-10% hover:via-sky-900 hover:via-30% hover:to-blue-900 to-90 focus:outline-none">
            <div className='flex justify-between'>
              <div className="flex items-center">
                <div
                  className="h-6 w-6 backdrop-blur bg-white/50 rounded-full mx-3 active:opacity-70 active:text-opacity-70 cursor-pointer transition duration-300">
                  {selectedProducts.length}
                </div>
                <div className='ml-3'>{t('goToCheckout')}</div>
              </div>
              <div className="font-[600] mr-2">{amountFormatter(total, 'ALL')}</div>
            </div>
          </button>
        </div>}
    </div>
  );
};

export default MenuForm;
